'use client'

import { useSession } from 'next-auth/react'

export function useDomainType() {
  const { data: session } = useSession()

  return session?.authContext?.type
}
